import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { HomeScreen } from '@/screens/HomeScreen';
import { StockChatScreen } from '@/screens/stock/StockChatScreen';
import { StockAnalysisScreen } from '@/screens/stock/StockAnalysisScreen';
import { WatchlistScreen } from '@/screens/WatchlistScreen';
import { HomeStackParamList } from './types';

const Stack = createStackNavigator<HomeStackParamList>();

/**
 * Home Stack Navigator
 * Handles navigation between home screen, watchlist, and stock analysis
 */
export const HomeNavigator: React.FC = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="HomeScreen" component={HomeScreen} />
      <Stack.Screen name="Watchlist" component={WatchlistScreen} />
      <Stack.Screen name="StockChat" component={StockChatScreen} />
      <Stack.Screen name="StockAnalysis" component={StockAnalysisScreen} />
    </Stack.Navigator>
  );
};
